module.exports = __webpack_public_path__ + "static/media/Ship-Meraviglia-galleria-meraviglia.c3779b1b.jpg";